<template>
  <div class="bzaym">
    <checker-offers-block :offers="checkerDisplayOffers" />
    <!-- =========================
         TEMPLATE #1: SWIPER (mobile + flag)
         ========================= -->
    <template v-if="isSwiperEnabled">
      <div class="showcase-wrapper">
        <!-- Прогресс -->
        <div class="swiper-pagination" ref="pagination"></div>

        <div class="swiper-text__label">Листайте влево</div>

        <div class="swiper showcase-swiper" ref="swiper">
          <div class="swiper-wrapper">
              <div
              class="swiper-slide"
              v-for="offer in mobileSwiperDisplayOffers"
              :key="offer.__mobileSwiperLoopKey || offer.id || offer.link"
            >
              <div class="card">
                <div class="card-top__img">
                  <img src="/img/bzaym.png" alt="" />
                </div>

                <div class="card-top">
                  <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
                </div>

                <div class="card-info__rate">
                  <star-rating :max="5" :current="offer.rating" />
                </div>

                <div class="card-info">
                  <div class="card-info__wrapper">
                    <div class="card-info__img">
                      <img src="/img/bzaymsum.svg" alt="" />
                    </div>
                    <div class="card-info__value">
                      до {{ numberFormat(offer.amount) }} ₽
                    </div>
                  </div>

                  <div class="card-info__wrapper">
                    <div class="card-info__img">
                      <img src="/img/bzaymperiod.svg" alt="" />
                    </div>
                    <div class="card-info__value">до {{ offer.period }} дней</div>
                  </div>

                  <div class="card-info__wrapper">
                    <div class="card-info__img">
                      <img src="/img/bzaympercent.svg" alt="" />
                    </div>
                    <div class="card-info__value">
                      без % -
                      <span v-if="offer.without_percent">да</span>
                      <span v-else>нет</span>
                    </div>
                  </div>
                </div>

                <div class="card-btn" @click="openLinks(offer)">
                  <button type="button">ПОЛУЧИТЬ ЗАЕМ</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Стрелки -->
          <button
            class="showcase-nav prev"
            ref="prevBtn"
            :class="{ hidden: !hasMovedFromFirst }"
          >
            ‹
          </button>
          <button class="showcase-nav next" ref="nextBtn">›</button>
        </div>
      </div>
    </template>

    <!-- =========================
         TEMPLATE #2: NO SWIPER (desktop OR flag false)
         ========================= -->
    <template v-else>
      <div class="showcase-wrapper">
        <div class="card" v-for="offer in showcaseOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link">
          <div class="card-top__img">
            <img src="/img/bzaym.png" alt="" />
          </div>

          <div class="card-top">
            <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
          </div>

          <div class="card-info__rate">
            <star-rating :max="5" :current="offer.rating" />
          </div>

          <div class="card-info">
            <div class="card-info__wrapper">
              <div class="card-info__img">
                <img src="/img/bzaymsum.svg" alt="" />
              </div>
              <div class="card-info__value">
                до {{ numberFormat(offer.amount) }} ₽
              </div>
            </div>

            <div class="card-info__wrapper">
              <div class="card-info__img">
                <img src="/img/bzaymperiod.svg" alt="" />
              </div>
              <div class="card-info__value">до {{ offer.period }} дней</div>
            </div>

            <div class="card-info__wrapper">
              <div class="card-info__img">
                <img src="/img/bzaympercent.svg" alt="" />
              </div>
              <div class="card-info__value">
                      без % -
                      <span v-if="offer.without_percent">да</span>
                      <span v-else>нет</span>
                    </div>
            </div>
          </div>

          <div class="card-btn" @click="openLinks(offer)">
            <button type="button">ПОЛУЧИТЬ ЗАЕМ</button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import * as Functions from "../assets/js/functions.js";
import StarRating from "@/components/StarRating";

import offerBucketsMixin from "../assets/js/offerBucketsMixin.js";
import mobileSwiperMixin from "../assets/js/mobileSwiperMixin.js";
import CheckerOffersBlock from "./CheckerOffersBlock.vue";

export default {
  name: "ShowcaseBzaym",
  mixins: [offerBucketsMixin, mobileSwiperMixin],
  components: { StarRating, CheckerOffersBlock },

  props: {
    offers: { type: Array, default: () => [] },
    checkerOffers: { type: Array, default: () => [] },
    settings: { type: Object, default: () => ({}) }, // ✅ важно, чтобы пришёл флаг
  },

  computed: {
    filteredOffers() {
      return this.getInlineOrderedOffers(this.displayedOffers);
    },

    checkerDisplayOffers() {
      return this.getCheckerDisplayOffers();
    },

    showcaseOffers() {
      return this.getInlineShowcaseOffers(this.filteredOffers);
    },

    // ✅ делаем устойчиво к "true"/1

  },

  methods: {
    numberFormat(n) {
      return Functions.numberFormat(n);
    },

    openLinks(offer) {
      window.open(offer.link, "_blank");
      (offer.links || []).forEach((l) => window.open(l, "_blank"));
    },

  },
};
</script>
<style lang="css">
@import url(../assets/css/bzaym.scss);
</style>
<style lang="css">
.star-rating {
  width: 50%;
}

.ozzaym .card-info__wrapper {

  display: flex;
  align-items: center;

}

.card-info__rate {
  margin-left: 30px;
  margin-bottom: 15px;
  width: 100%;
}

  .swiper-text__label{
  display: none;
}
@media (max-width: 768px) {
  .swiper-text__label{
  display: block;
  font-weight: 400;
  font-size: 16px;
}
  .showcase-nav.hidden {
    opacity: 0;
    pointer-events: none;
  }
}

/* ===========================
   ДЕСКТОП (старый вид, без свайпера)
   =========================== */

@media (min-width: 768px) {

  /* полосы и стрелки вообще не показываем */
  .showcase-wrapper>.swiper-pagination,
  .showcase-nav {
    display: none !important;
  }

  /* обычная сетка карточек */
  .bzaym .showcase-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    justify-content: flex-start;
    /* или center, если хочешь по центру */
  }

  .bzaym .showcase-swiper .swiper-slide {
    flex: 0 0 355px;
    /* ЖЁСТКАЯ ширина колонки */
    max-width: 355px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }

  .bzaym .showcase-swiper .card {
    width: 100%;
    max-width: 355px;
    box-sizing: border-box;
  }
}

/* ===========================
   МОБИЛКА (Swiper + прогресс + стрелки)
   =========================== */
@media (max-width: 767px) {

  .showcase-wrapper {
    padding: 0 0 20px;
  }

  /* ПРОГРЕССБАР СВЕРХУ */
  .bzaym .showcase-wrapper>.swiper-pagination {
    display: block;
    position: relative;
    max-width: 310px;
    /* как карточка */
    width: 100%;
    height: 6px;
    margin: 0 auto 16px;
    /* ЦЕНТРИРУЕМ */
    background: #e5e5e5;
    border-radius: 999px;
    overflow: hidden;
  }

  .bzaym .showcase-wrapper>.swiper-pagination .swiper-pagination-progressbar-fill {
    background: #19A5D8;
    transform-origin: left center;
    transition: transform .25s ease;
    width: 100%;
    height: 100%;
    transform: scaleX(0);
  }

  .showcase-swiper {
    overflow: visible;
    /* чтобы стрелки не обрезались */
    position: relative;
  }

  .bzaym .swiper-slide {
    display: flex;
    justify-content: center;
  }

  .swiper-slide .card {
    max-width: 310px;
    width: 100%;
  }

  /* СТРЕЛКИ */
  .bzaym .showcase-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 29px;
    height: 29px;
    color: #fff;
    background: #19A5D8;
    border-radius: 50%;
    border: none;

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    cursor: pointer;
  }

  .showcase-nav.prev {
    left: 0px;
  }

  .showcase-nav.next {
    right: 0px;
  }
}

@media (max-width: 430px) {
  .bzaym .showcase-wrapper {
    flex-direction: row;
  }
}
</style>

